import React from 'react';
import { partition } from 'lodash';
import { GeoJSON as GeoJSONLeaflet } from 'react-leaflet';
import { latLng } from 'leaflet';
import Marker from '../Marker';
import appsignal from '../../../Services/ErrorReportingService';

const geometriesFromPost = (data: string) => {
  let features = [];

  try {
    features = JSON.parse(data)?.features || [];
  } catch (e) {
    appsignal.sendError(new Error(`Error parsing GeoJSON data: ${data}, error: ${e}`));
  }

  return partition(features, (o) => {
    return o.geometry.type === 'Point';
  });
};

function GeoJSON({ data }: { data: string }) {
  const [points, otherFeatures] = geometriesFromPost(data);

  return (
    <>
      {points.map((feature) => (
        <Marker
          key={feature.geometry.coordinates.join(',')}
          position={latLng(feature.geometry.coordinates.reverse())}
          title={feature?.properties?.name}
          status="LocationSearching"
        />
      ))}
      {otherFeatures.length > 0 && (
        <GeoJSONLeaflet
          data={{
            type: 'FeatureCollection',
            features: otherFeatures,
          }}
        />
      )}
    </>
  );
}

export default GeoJSON;
